import { Airplane as AirplaneIcon } from "@phosphor-icons/react/Airplane";
import { AirplaneTakeoff as AirplaneTakeoffIcon } from "@phosphor-icons/react/AirplaneTakeoff";
import { AirTrafficControl as AirTrafficControlIcon } from "@phosphor-icons/react/AirTrafficControl";
import { AnchorSimple as AnchorSimpleIcon } from "@phosphor-icons/react/AnchorSimple";
import { Bank as BankIcon } from "@phosphor-icons/react/Bank";
import { Baseball as BaseballIcon } from "@phosphor-icons/react/Baseball";
import { Basketball as BasketballIcon } from "@phosphor-icons/react/Basketball";
import { Bed as BedIcon } from "@phosphor-icons/react/Bed";
import { BeerBottle as BeerBottleIcon } from "@phosphor-icons/react/BeerBottle";
import { BeerStein as BeerSteinIcon } from "@phosphor-icons/react/BeerStein";
import { Bicycle as BicycleIcon } from "@phosphor-icons/react/Bicycle";
import { Boat as BoatIcon } from "@phosphor-icons/react/Boat";
import { BookOpen as BookOpenIcon } from "@phosphor-icons/react/BookOpen";
import { BuildingOffice as BuildingOfficeIcon } from "@phosphor-icons/react/BuildingOffice";
import { Bus as BusIcon } from "@phosphor-icons/react/Bus";
import { Butterfly as ButterflyIcon } from "@phosphor-icons/react/Butterfly";
import { Circle as CircleIcon } from "@phosphor-icons/react/Circle";
import { Coffee as CoffeeIcon } from "@phosphor-icons/react/Coffee";
import { Cow as CowIcon } from "@phosphor-icons/react/Cow";
import { CreditCard as CreditCardIcon } from "@phosphor-icons/react/CreditCard";
import { Cricket as CricketIcon } from "@phosphor-icons/react/Cricket";
import { Cross as CrossIcon } from "@phosphor-icons/react/Cross";
import { DropSimple as DropSimpleIcon } from "@phosphor-icons/react/DropSimple";
import { Envelope as EnvelopeIcon } from "@phosphor-icons/react/Envelope";
import { Factory as FactoryIcon } from "@phosphor-icons/react/Factory";
import { FilmSlate as FilmSlateIcon } from "@phosphor-icons/react/FilmSlate";
import { Fire as FireIcon } from "@phosphor-icons/react/Fire";
import { FirstAid as FirstAidIcon } from "@phosphor-icons/react/FirstAid";
import { Flag as FlagIcon } from "@phosphor-icons/react/Flag";
import { Football as FootballIcon } from "@phosphor-icons/react/Football";
import { ForkKnife as ForkKnifeIcon } from "@phosphor-icons/react/ForkKnife";
import { GasPump as GasPumpIcon } from "@phosphor-icons/react/GasPump";
import { Golf as GolfIcon } from "@phosphor-icons/react/Golf";
import { GraduationCap as GraduationCapIcon } from "@phosphor-icons/react/GraduationCap";
import { Hamburger as HamburgerIcon } from "@phosphor-icons/react/Hamburger";
import { HandsPraying as HandsPrayingIcon } from "@phosphor-icons/react/HandsPraying";
import { Hospital as HospitalIcon } from "@phosphor-icons/react/Hospital";
import { LetterCircleH as LetterCircleHIcon } from "@phosphor-icons/react/LetterCircleH";
import { LetterCircleP as LetterCirclePIcon } from "@phosphor-icons/react/LetterCircleP";
import { Log as LogIcon } from "@phosphor-icons/react/Log";
import { MapPin as MapPinIcon } from "@phosphor-icons/react/MapPin";
import { MapPinSimple as MapPinSimpleIcon } from "@phosphor-icons/react/MapPinSimple";
import { Martini as MartiniIcon } from "@phosphor-icons/react/Martini";
import { MaskHappy as MaskHappyIcon } from "@phosphor-icons/react/MaskHappy";
import { MusicNotesSimple as MusicNotesSimpleIcon } from "@phosphor-icons/react/MusicNotesSimple";
import { Palette as PaletteIcon } from "@phosphor-icons/react/Palette";
import { PersonSimpleRun as PersonSimpleRunIcon } from "@phosphor-icons/react/PersonSimpleRun";
import { PersonSimpleSki as PersonSimpleSkiIcon } from "@phosphor-icons/react/PersonSimpleSki";
import { PersonSimpleSwim as PersonSimpleSwimIcon } from "@phosphor-icons/react/PersonSimpleSwim";
import { Phone as PhoneIcon } from "@phosphor-icons/react/Phone";
import { PhoneCall as PhoneCallIcon } from "@phosphor-icons/react/PhoneCall";
import { Plant as PlantIcon } from "@phosphor-icons/react/Plant";
import { PoliceCar as PoliceCarIcon } from "@phosphor-icons/react/PoliceCar";
import { Prescription as PrescriptionIcon } from "@phosphor-icons/react/Prescription";
import { ProhibitInset as ProhibitInsetIcon } from "@phosphor-icons/react/ProhibitInset";
import { ShoppingCartSimple as ShoppingCartSimpleIcon } from "@phosphor-icons/react/ShoppingCartSimple";
import { SoccerBall as SoccerBallIcon } from "@phosphor-icons/react/SoccerBall";
import { SolarPanel as SolarPanelIcon } from "@phosphor-icons/react/SolarPanel";
import { Square as SquareIcon } from "@phosphor-icons/react/Square";
import { Star as StarIcon } from "@phosphor-icons/react/Star";
import { StarAndCrescent as StarAndCrescentIcon } from "@phosphor-icons/react/StarAndCrescent";
import { StarOfDavid as StarOfDavidIcon } from "@phosphor-icons/react/StarOfDavid";
import { Storefront as StorefrontIcon } from "@phosphor-icons/react/Storefront";
import { Student as StudentIcon } from "@phosphor-icons/react/Student";
import { Subway as SubwayIcon } from "@phosphor-icons/react/Subway";
import { TennisBall as TennisBallIcon } from "@phosphor-icons/react/TennisBall";
import { Tent as TentIcon } from "@phosphor-icons/react/Tent";
import { Toilet as ToiletIcon } from "@phosphor-icons/react/Toilet";
import { Train as TrainIcon } from "@phosphor-icons/react/Train";
import { Tram as TramIcon } from "@phosphor-icons/react/Tram";
import { TrashSimple as TrashSimpleIcon } from "@phosphor-icons/react/TrashSimple";
import { Tree as TreeIcon } from "@phosphor-icons/react/Tree";
import { TreeEvergreen as TreeEvergreenIcon } from "@phosphor-icons/react/TreeEvergreen";
import { Triangle as TriangleIcon } from "@phosphor-icons/react/Triangle";
import { Wall as WallIcon } from "@phosphor-icons/react/Wall";
import { Warehouse as WarehouseIcon } from "@phosphor-icons/react/Warehouse";
import { Warning as WarningIcon } from "@phosphor-icons/react/Warning";
import { Wheelchair as WheelchairIcon } from "@phosphor-icons/react/Wheelchair";

export const BASIC_MARKERS = {
	circle: {
		Icon: (props) => (
			<CircleIcon
				weight="fill"
				{...props}
			/>
		),
	},
	square: {
		Icon: (props) => (
			<SquareIcon
				weight="fill"
				{...props}
			/>
		),
	},
	star: {
		Icon: (props) => (
			<StarIcon
				weight="fill"
				{...props}
			/>
		),
	},
	firstAid: {
		Icon: (props) => (
			<FirstAidIcon
				weight="fill"
				{...props}
			/>
		),
	},
	x: {
		Icon: (props) => (
			<FirstAidIcon
				weight="fill"
				{...props}
			/>
		),
		style: {
			transform: "rotate(45deg)",
		},
	},
	airplane: {
		Icon: (props) => (
			<AirplaneIcon
				weight="fill"
				{...props}
			/>
		),
	},
	airplaneTakeoff: {
		Icon: (props) => (
			<AirplaneTakeoffIcon
				weight="fill"
				{...props}
			/>
		),
	},
	triangle: {
		Icon: (props) => (
			<TriangleIcon
				weight="fill"
				{...props}
			/>
		),
	},
	airfield: {
		Icon: (props) => (
			<AirTrafficControlIcon
				weight="fill"
				{...props}
			/>
		),
	},
	alcoholShop: {
		Icon: (props) => (
			<BeerBottleIcon
				weight="fill"
				{...props}
			/>
		),
	},
	americaFootball: {
		Icon: (props) => (
			<FootballIcon
				weight="fill"
				{...props}
			/>
		),
	},
	artGallery: {
		Icon: (props) => (
			<PaletteIcon
				weight="fill"
				{...props}
			/>
		),
	},
	bank: {
		Icon: (props) => (
			<CreditCardIcon
				weight="fill"
				{...props}
			/>
		),
	},
	bar: {
		Icon: (props) => (
			<MartiniIcon
				weight="fill"
				{...props}
			/>
		),
	},
	baseball: {
		Icon: (props) => (
			<BaseballIcon
				weight="fill"
				{...props}
			/>
		),
	},
	basketball: {
		Icon: (props) => (
			<BasketballIcon
				weight="fill"
				{...props}
			/>
		),
	},
	beer: {
		Icon: (props) => (
			<BeerSteinIcon
				weight="fill"
				{...props}
			/>
		),
	},
	bicycle: {
		Icon: (props) => (
			<BicycleIcon
				weight="fill"
				{...props}
			/>
		),
	},
	bus: {
		Icon: (props) => (
			<BusIcon
				weight="fill"
				{...props}
			/>
		),
	},
	coffee: {
		Icon: (props) => (
			<CoffeeIcon
				weight="fill"
				{...props}
			/>
		),
	},
	campsite: {
		Icon: (props) => (
			<TentIcon
				weight="fill"
				{...props}
			/>
		),
	},
	cemetery: {
		Icon: (props) => (
			<CrossIcon
				weight="fill"
				{...props}
			/>
		),
	},
	cinema: {
		Icon: (props) => (
			<FilmSlateIcon
				weight="fill"
				{...props}
			/>
		),
	},
	college: {
		Icon: (props) => (
			<GraduationCapIcon
				weight="fill"
				{...props}
			/>
		),
	},
	commercial: {
		Icon: (props) => (
			<BuildingOfficeIcon
				weight="fill"
				{...props}
			/>
		),
	},
	cricket: {
		Icon: (props) => (
			<CricketIcon
				weight="fill"
				{...props}
			/>
		),
	},
	dam: {
		Icon: (props) => (
			<DropSimpleIcon
				weight="fill"
				{...props}
			/>
		),
	},
	danger: {
		Icon: (props) => (
			<WarningIcon
				weight="fill"
				{...props}
			/>
		),
	},
	disability: {
		Icon: (props) => (
			<WheelchairIcon
				weight="fill"
				{...props}
			/>
		),
	},
	embassy: {
		Icon: (props) => (
			<FlagIcon
				weight="fill"
				{...props}
			/>
		),
	},
	emergencyTelephone: {
		Icon: (props) => (
			<PhoneCallIcon
				weight="fill"
				{...props}
			/>
		),
	},
	fastFood: {
		Icon: (props) => (
			<HamburgerIcon
				weight="fill"
				{...props}
			/>
		),
	},
	ferry: {
		Icon: (props) => (
			<BoatIcon
				weight="fill"
				{...props}
			/>
		),
	},
	fireStation: {
		Icon: (props) => (
			<FireIcon
				weight="fill"
				{...props}
			/>
		),
	},
	fuel: {
		Icon: (props) => (
			<GasPumpIcon
				weight="fill"
				{...props}
			/>
		),
	},
	garden: {
		Icon: (props) => (
			<PlantIcon
				weight="fill"
				{...props}
			/>
		),
	},
	golf: {
		Icon: (props) => (
			<GolfIcon
				weight="fill"
				{...props}
			/>
		),
	},
	grocery: {
		Icon: (props) => (
			<ShoppingCartSimpleIcon
				weight="fill"
				{...props}
			/>
		),
	},
	harbor: {
		Icon: (props) => (
			<AnchorSimpleIcon
				weight="fill"
				{...props}
			/>
		),
	},
	heliport: {
		Icon: (props) => (
			<LetterCircleHIcon
				weight="fill"
				{...props}
			/>
		),
	},
	hospital: {
		Icon: (props) => (
			<HospitalIcon
				weight="fill"
				{...props}
			/>
		),
	},
	ndustrial: {
		Icon: (props) => (
			<FactoryIcon
				weight="fill"
				{...props}
			/>
		),
	},
	library: {
		Icon: (props) => (
			<BookOpenIcon
				weight="fill"
				{...props}
			/>
		),
	},
	lodging: {
		Icon: (props) => (
			<BedIcon
				weight="fill"
				{...props}
			/>
		),
	},
	logging: {
		Icon: (props) => (
			<LogIcon
				weight="fill"
				{...props}
			/>
		),
	},
	marker: {
		Icon: (props) => (
			<MapPinIcon
				weight="fill"
				{...props}
			/>
		),
	},
	monument: {
		Icon: (props) => (
			<MapPinSimpleIcon
				weight="fill"
				{...props}
			/>
		),
	},
	museum: {
		Icon: (props) => (
			<BankIcon
				weight="fill"
				{...props}
			/>
		),
	},
	music: {
		Icon: (props) => (
			<MusicNotesSimpleIcon
				weight="fill"
				{...props}
			/>
		),
	},
	oilWell: {
		Icon: (props) => (
			<SolarPanelIcon
				weight="fill"
				{...props}
			/>
		),
	},
	park: {
		Icon: (props) => (
			<TreeIcon
				weight="fill"
				{...props}
			/>
		),
	},
	park2: {
		Icon: (props) => (
			<TreeEvergreenIcon
				weight="fill"
				{...props}
			/>
		),
	},
	parking: {
		Icon: (props) => (
			<LetterCirclePIcon
				weight="fill"
				{...props}
			/>
		),
	},
	pharmacy: {
		Icon: (props) => (
			<PrescriptionIcon
				weight="fill"
				{...props}
			/>
		),
	},
	pitch: {
		Icon: (props) => (
			<PersonSimpleRunIcon
				weight="fill"
				{...props}
			/>
		),
	},
	placeOfWorship: {
		Icon: (props) => (
			<HandsPrayingIcon
				weight="fill"
				{...props}
			/>
		),
	},
	police: {
		Icon: (props) => (
			<PoliceCarIcon
				weight="fill"
				{...props}
			/>
		),
	},
	post: {
		Icon: (props) => (
			<EnvelopeIcon
				weight="fill"
				{...props}
			/>
		),
	},
	prison: {
		Icon: (props) => (
			<WallIcon
				weight="fill"
				{...props}
			/>
		),
	},
	rail: {
		Icon: (props) => (
			<TrainIcon
				weight="fill"
				{...props}
			/>
		),
	},
	railAbove: {
		Icon: (props) => (
			<TramIcon
				weight="fill"
				{...props}
			/>
		),
	},
	railUnderground: {
		Icon: (props) => (
			<SubwayIcon
				weight="fill"
				{...props}
			/>
		),
	},
	religiousJewish: {
		Icon: (props) => (
			<StarOfDavidIcon
				weight="fill"
				{...props}
			/>
		),
	},
	religiousMuslim: {
		Icon: (props) => (
			<StarAndCrescentIcon
				weight="fill"
				{...props}
			/>
		),
	},
	restaurant: {
		Icon: (props) => (
			<ForkKnifeIcon
				weight="fill"
				{...props}
			/>
		),
	},

	roadblock: {
		Icon: (props) => (
			<ProhibitInsetIcon
				weight="fill"
				{...props}
			/>
		),
	},
	school: {
		Icon: (props) => (
			<StudentIcon
				weight="fill"
				{...props}
			/>
		),
	},
	shop: {
		Icon: (props) => (
			<StorefrontIcon
				weight="fill"
				{...props}
			/>
		),
	},
	skiing: {
		Icon: (props) => (
			<PersonSimpleSkiIcon
				weight="fill"
				{...props}
			/>
		),
	},
	slaughterhouse: {
		Icon: (props) => (
			<CowIcon
				weight="fill"
				{...props}
			/>
		),
	},
	soccer: {
		Icon: (props) => (
			<SoccerBallIcon
				weight="fill"
				{...props}
			/>
		),
	},
	squareStroked: {
		Icon: (props) => (
			<SquareIcon
				weight="fill"
				{...props}
			/>
		),
	},
	starStroked: {
		Icon: (props) => (
			<StarIcon
				weight="fill"
				{...props}
			/>
		),
	},
	swimming: {
		Icon: (props) => (
			<PersonSimpleSwimIcon
				weight="fill"
				{...props}
			/>
		),
	},
	telephone: {
		Icon: (props) => (
			<PhoneIcon
				weight="fill"
				{...props}
			/>
		),
	},
	tennis: {
		Icon: (props) => (
			<TennisBallIcon
				weight="fill"
				{...props}
			/>
		),
	},
	theatre: {
		Icon: (props) => (
			<MaskHappyIcon
				weight="fill"
				{...props}
			/>
		),
	},
	toilets: {
		Icon: (props) => (
			<ToiletIcon
				weight="fill"
				{...props}
			/>
		),
	},
	townHall: {
		Icon: (props) => (
			<BankIcon
				weight="fill"
				{...props}
			/>
		),
	},
	triangleStroked: {
		Icon: (props) => (
			<TriangleIcon
				weight="fill"
				{...props}
			/>
		),
	},
	warehouse: {
		Icon: (props) => (
			<WarehouseIcon
				weight="fill"
				{...props}
			/>
		),
	},
	wasteBasket: {
		Icon: (props) => (
			<TrashSimpleIcon
				weight="fill"
				{...props}
			/>
		),
	},
	water: {
		Icon: (props) => (
			<DropSimpleIcon
				weight="fill"
				{...props}
			/>
		),
	},
	wetland: {
		Icon: (props) => (
			<PlantIcon
				weight="fill"
				{...props}
			/>
		),
	},
	zoo: {
		Icon: (props) => (
			<ButterflyIcon
				weight="fill"
				{...props}
			/>
		),
	},
};
